import { render, staticRenderFns } from "./TemperChart.vue?vue&type=template&id=4affe211&scoped=true&"
import script from "./TemperChart.vue?vue&type=script&lang=js&"
export * from "./TemperChart.vue?vue&type=script&lang=js&"
import style0 from "./TemperChart.vue?vue&type=style&index=0&id=4affe211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affe211",
  null
  
)

export default component.exports